<script>
"use strict";

import ApiStocks from '@/Services/ApiStocks.js';
import { Bar } from 'vue-chartjs'

export default {
    name: 'CanvasPE',
    extends: Bar,
    mounted () {
        this.init()
    },
    data () {
        return {
        }
    },
    methods: {
        init() {
            let companies = this.$store.getters.getMapCompanies;

            let label_array = [];
            let data_array = [];

            const company = companies.get(this.company_id);

            company.CompanyReports.forEach(r => {
                label_array.push(r.period);
                data_array.push(Math.round(r.pe));
            });

            this.renderChart({
                labels: label_array,
                datasets: [
                    {
                        label: 'P/E',
                        backgroundColor: '#258183',
                        data: data_array
                    }
                ]
            })
        },
    },
    props: {
        company_id : Number
    },
    watch: {
        company_id() {
            this.init()
        }
    }
}

</script>

<style scoped>

</style>
